var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5199 9.18164C15.367 9.18164 13.2126 11.5586 13.7293 14.4634L14.5175 18.8614C14.8284 20.6042 16.6282 22.0321 18.5199 22.0321C20.4116 22.0321 22.2157 20.6083 22.5222 18.8614L23.306 14.4634C23.8227 11.5586 21.6683 9.18164 18.5155 9.18164H18.5199Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3465 24.0615L22.864 22.3555C21.7124 23.4069 20.1622 24.0779 18.5201 24.0779C16.8781 24.0779 15.3279 23.4069 14.1763 22.3555L8.68946 24.0615C7.67355 24.3765 6.84155 25.4566 6.84155 26.4548V31.0002H30.1944V26.4548C30.1944 25.4566 29.3624 24.3765 28.3465 24.0615Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3572 6.45312C23.0523 6.45312 21.9313 6.87861 21.0862 7.56593C22.2028 7.94641 23.1968 8.57236 23.9588 9.41106C25.2724 10.8552 25.8198 12.819 25.4651 14.7992L24.6813 19.1972C24.6769 19.2217 24.6638 19.2504 24.6594 19.2749C26.4372 19.1317 28.0662 17.7816 28.3596 16.1329L29.1434 11.7349C29.6601 8.83011 27.5057 6.45312 24.3572 6.45312Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0769 9.41149C14.1366 8.2455 15.6298 7.48863 17.2982 7.23907L17.4689 6.28173C17.99 3.37698 15.8312 1 12.6828 1C9.53433 1 7.37552 3.37698 7.89223 6.28173L8.68044 10.6798C8.92128 12.0462 10.0817 13.204 11.4786 13.65C11.4742 12.0749 12.0259 10.5775 13.0769 9.41149Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99315 22.1226L12.8494 20.6129C12.626 20.1629 12.4421 19.6965 12.3546 19.2015L11.7503 15.8058C10.4585 15.6053 9.26741 15.0244 8.3347 14.1775L2.84791 15.8835C1.832 16.1985 1 17.2786 1 18.2769V22.8222H6.62692C7.03854 22.5194 7.49833 22.278 7.99315 22.1226Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1834 21.7124L28.701 19.6267C27.9128 20.3427 26.9363 20.8663 25.8722 21.1364L29.0382 22.1223C30.9474 22.7197 32.3837 24.5811 32.3837 26.459V28.2755H36.0313V23.7302C36.0313 22.7319 35.1993 22.0274 34.1834 21.7124Z",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersWhiteIcon);
export default __webpack_public_path__ + "static/media/UsersWhiteIcon.f8a92b05a085abb8a992ae1d4fde8c71.svg";
export { ForwardRef as ReactComponent };